// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_dw-0";
export var fileCarousel = "_dw-2";
export var removeFileButton = "_dw-1";